import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { BudgetStatement } from '@/modules/finances/types';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import type SimpleBar from 'simplebar-react';
interface UseBudgetStatementListProps {
  budgetStatements: BudgetStatement[];
  asSectionContent?: boolean;
}
export function useBudgetStatementList(t0) {
  const $ = _c(9);
  const {
    budgetStatements,
    asSectionContent: t1
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  const simpleBarRef = useRef(null);
  const cardContentRef = useRef(null);
  const itemsWrapperRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      from: "sm",
      to: "md"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isLargeMobile = useMediaQuery(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      from: "md"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTablet = useMediaQuery(t3);
  let t4;
  let t5;
  if ($[2] !== asSectionContent || $[3] !== budgetStatements.length || $[4] !== isLargeMobile || $[5] !== isTablet) {
    t4 = () => {
      if (!asSectionContent) {
        return;
      }
      const simpleBarEl = simpleBarRef.current?.el;
      const cardContentEl = cardContentRef.current;
      const itemsWrapperEl = itemsWrapperRef.current;
      if (!simpleBarEl || !cardContentEl || !itemsWrapperEl) {
        return;
      }
      const teamsCount = budgetStatements.length;
      let config = null;
      if (isTablet) {
        config = {
          maxHeight: "798px",
          maxItems: 7
        };
      } else {
        if (isLargeMobile) {
          config = {
            maxHeight: "1078px",
            maxItems: 7
          };
        }
      }
      if (!config) {
        simpleBarEl.style.maxHeight = "";
        cardContentEl.style.paddingRight = "";
        return;
      }
      if (teamsCount > config.maxItems) {
        simpleBarEl.style.maxHeight = config.maxHeight;
        cardContentEl.style.paddingRight = "4px";
        itemsWrapperEl.style.paddingRight = "12px";
      }
    };
    t5 = [isTablet, isLargeMobile, budgetStatements.length, asSectionContent];
    $[2] = asSectionContent;
    $[3] = budgetStatements.length;
    $[4] = isLargeMobile;
    $[5] = isTablet;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      simpleBarRef,
      cardContentRef,
      itemsWrapperRef
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}